import { render, staticRenderFns } from "./ModalFormulario.vue?vue&type=template&id=52641450"
import script from "./ModalFormulario.vue?vue&type=script&lang=js"
export * from "./ModalFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports